// extracted by mini-css-extract-plugin
export default {"aiButton":"AIButton_aiButton__O3Eyo","aiIconLg":"AIButton_aiIconLg__kTUoV","aiIconSm":"AIButton_aiIconSm__11FNS"};